import { render, staticRenderFns } from "./CardPlanoMensal.vue?vue&type=template&id=2cb09f04&scoped=true"
import script from "./CardPlanoMensal.vue?vue&type=script&lang=js"
export * from "./CardPlanoMensal.vue?vue&type=script&lang=js"
import style0 from "./CardPlanoMensal.vue?vue&type=style&index=0&id=2cb09f04&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb09f04",
  null
  
)

export default component.exports